import { RoutePathProps } from "./types";

export function addChildRoute(
  parent: RoutePathProps,
  childrenMap: Record<string, RoutePathProps>
): RoutePathProps {
  const parentPath = parent.path || '';

  const normalizedParentPath = parentPath.endsWith('/')
    ? parentPath.slice(0, -1)
    : parentPath;

  const mergedChildren: RoutePathProps[] = [];

  for (const key in childrenMap) {
    if (Object.prototype.hasOwnProperty.call(childrenMap, key)) {
      const child = childrenMap[key];

      const normalizedChildPath = child.path.startsWith('/')
        ? child.path
        : `/${child.path}`;

      // ✅ Merge parent + child
      const newPath = `${normalizedParentPath}${normalizedChildPath}`;

      // ✅ Recursively merge sub-children (if any)
      let mergedChild: RoutePathProps = {
        ...child,
        path: newPath,
      };

      if (child.children && Array.isArray(child.children)) {
        mergedChild = addChildRoute(mergedChild, child.children.reduce((map, c) => {
          map[c.name] = c;
          return map;
        }, {} as Record<string, RoutePathProps>));
      }

      mergedChildren.push(mergedChild);
    }
  }

  return {
    ...parent,
    children: mergedChildren,
  };
}

// export function addChildRoute(
//   parent: RoutePathProps
// ): RoutePathProps {
//   const base = parent.path.replace(/\/$/, ""); // remove trailing slash

//   const updatedChildren = parent.children?.map(child => {
//     // build child's absolute path
//     const childPath = child.path.startsWith("/")
//       ? `${base}${child.path}`
//       : `${base}/${child.path}`;

//     // recursively process nested children
//     return addChildRoute({
//       ...child,
//       path: childPath
//     });
//   });

//   return {
//     ...parent,
//     children: updatedChildren
//   };
// }


export const buildMenu = (routes: RoutePathProps[]): RoutePathProps[] => {
  if (!Array.isArray(routes)) {
    return [];
  }

  return routes.reduce((acc: RoutePathProps[], route) => {
    // Check if the current route is visible in the navigation
    if (route.visibleInNav === true) {
      // Create a copy of the route
      let newRoute = { ...route };

      // Recursively process children if they exist
      if (Array.isArray(newRoute.children)) {
        newRoute.children = buildMenu(newRoute.children);

        // If the children array is now empty, remove the children property
        if (newRoute.children.length === 0) {
          delete newRoute.children;
        }
      }

      // Add the (potentially modified) route to the accumulator
      acc.push(newRoute);
    }
    // If visibleInNav is not true, the route and its subtree are dropped.

    return acc;
  }, []);
};

